import { call, put, takeLatest, all } from 'redux-saga/effects';
import config from 'config';
import apiClient from '../helpers/apiClient';
import * as actionTypes from '../actionTypes/frameSize';

let _client = null;

function* getFrameSizeData({ formData, phone }) {
    const successAction = { type: actionTypes.GET_FRAME_SIZE_SUCCESS };
    const errorAction = { type: actionTypes.GET_FRAME_SIZE_FAIL };
    try {
        const response = yield call(async () => _client.post(`${config.apiPath.frameSize}${phone ? '?phone=' + phone : ''}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }));
        successAction.data = response && response.result;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

function* storeFrameSize({ formData }) {
    const successAction = { type: actionTypes.STORE_FRAME_SIZE_SUCCESS };
    const errorAction = { type: actionTypes.STORE_FRAME_SIZE_FAIL };
    try {
        const response = yield call(async () => _client.post(`${config.apiPath.storeFrameSize}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }));
        successAction.data = response && response.result;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

export function* runFrameSizeCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeLatest(actionTypes.GET_FRAME_SIZE, getFrameSizeData),
        takeLatest(actionTypes.STORE_FRAME_SIZE, storeFrameSize)
    ]);
}
